import React, { useState, useEffect } from "react";
import { withRouter } from "react-router";
import { ImageURL } from "@/service/config";
import { getEnglishList } from "@/service/video";
import styled from "styled-components";
import { Popover } from "antd";
import I18n from "@/I18n";
import _ from "lodash";

import bg_1 from "@/assets/img/coverPage/coverPage_1.png";
import bg_2 from "@/assets/img/coverPage/coverPage_2.png";
import bg_3 from "@/assets/img/coverPage/coverPage_3.png";
import logo from "@/assets/img/coverPage/coverPage_title.png";
import logo2 from "@/assets/img/coverPage/logo.svg";
import icon_facebook from "@/assets/img/coverPage/icon_facebook.svg";
import icon_instagram from "@/assets/img/coverPage/icon_instagram.svg";
import icon_phone from "@/assets/img/coverPage/icon_phone.svg";
import icon_wx from "@/assets/img/coverPage/icon_wx.svg";
import icon_youtube from "@/assets/img/coverPage/icon_youtube.svg";
import wechat from "@/assets/img/coverPage/wx_ewm.png";
import icon_facebook2 from "@/assets/img/coverPage/icon_facebook_2.svg";
import icon_instagram2 from "@/assets/img/coverPage/icon_instagram_2.svg";
import icon_phone2 from "@/assets/img/coverPage/icon_phone_2.svg";
import icon_youtube2 from "@/assets/img/coverPage/icon_youtube_2.svg";

function En_Page(props) {
  const [list, setList] = useState([]);
  const [isOdd, setIsOdd] = useState(false);

  const languageArr = [
    {
      type: "中文简体",
      language: "zh-CN",
    },
    {
      type: "中文繁体",
      language: "zh-TW",
    },
    {
      type: "English",
      language: "en",
    },
    {
      type: "Français",
      language: "fr",
    },
  ];
  const getIndex = () => {
    return _.findIndex(languageArr, (o) => o.language === I18n.language);
  };
  useEffect(() => {
    getEnglishList().then((res) => {
      setList(res.data);
      if (res.data.length % 2 === 0) {
        setIsOdd(false);
      } else {
        setIsOdd(true);
      }
    });
  }, []);

  // useEffect(() => {
  //   const language = I18n.language;
  //   if (language === "zh-TW" || language === "zh-CN") {
  //     props.history.push("/");
  //   }
  // }, [getIndex]);

  const setLocal = (val) => {
    if (val === "en") {
      localStorage.setItem("language", "en");
      I18n.changeLanguage("en");
      window.location.href = "/en";
    } else if (val === "zh-TW") {
      localStorage.setItem("language", "zh-TW");
      I18n.changeLanguage("zh-TW");
      window.location.href = "/home";
    } else if (val === "fr" && window.FRENCH_LINK) {
      window.location.href = window.FRENCH_LINK ?? "";
    }
  };

  return (
    <PageWrapper>
      <img src={bg_1} alt="" className="bg" />
      <div className="center">
        <div className="center_nav">
          <img alt="" className="center_nav_logo" src={logo} />
          <div className="center_nav_li">
            <p className="link" onClick={() => setLocal("en")}>
              EN
            </p>
            <p className="link" onClick={() => setLocal("fr")}>
              FR
            </p>
            <p className="link" onClick={() => setLocal("zh-TW")}>
              中
            </p>
          </div>
        </div>
        {/* <h1 className="title_h1">Welcome to GT Wealth.</h1> */}
        <h6 className="title_h6">
          TAILORED MANAGEMENT FOR YOUR TAXES, WEALTH, AND LEGACY.
        </h6>
        <p className="title_p">
          Welcome to <span>GUARDIAN TRUST.</span> High net worth clients who
          mandate tailored excellence in tax structuring, wealth management, and
          legacy planning choose Guardian Trust to secure assets that are not
          only preserved, but positioned for enduring growth. Partnering with
          our high net worth team grants you the privilege of maintaining a
          winning edge. Clients entrust Guardian Trust for our tailored approach
          to tax savings, wealth management, and legacy planning, combined with
          a strong institutional brokerage platform through which assets are
          directed and administered with leading financial institutions,
          including BMO, RBCI, Fidelity, Canada Life, Manulife, and Sun Life.
        </p>
        <p className="title_p2">CHOOSE THE STATUS THAT BEST REPRESENT YOU.</p>
        {/* 列表 */}
        <div className="center_list">
          {list.map((item) => (
            <a href={item.link} className="item" key={item.id}>
              <img alt="" src={ImageURL + item.img} />
              <div className="name">
                <p>{item.name}</p>
              </div>
              {item.remark ? <p className="remark">{item.remark}</p> : null}
            </a>
          ))}
        </div>
      </div>
      {/* 底部 */}
      <div className="footer">
        <img alt="" src={bg_3} className="footer_bg" />
        <img src={bg_2} alt="" className="footer_bg_2" />
        <div className="footer_center">
          <img alt="" src={logo2} className="footer_logo" />
          <div className="footer_list">
            <div className="footer_list_li">
              <p className="footer_list_li_title">Office Addresses:</p>
              <p className="footer_list_li_p">
                405 – 6388 No. 3 Road, Richmond, BC
              </p>
              <p className="footer_list_li_p">
                N500 – 675 Cochrane Drive, Markham, ON
              </p>
              <p className="footer_list_li_p">
                300 - 1701 Centre Street NW, Calgary, AB
              </p>
            </div>
            <div className="footer_list_li">
              <p className="footer_list_li_title">Contact Us:</p>
              <div className="footer_list_li_link">
                <Popover
                  content={<p>Tel: (604) 278-0122</p>}
                  title={false}
                  // placement="top"
                  placement="topLeft"
                  arrowPointAtCenter
                >
                  <p className="link_icon">
                    <img alt="" src={icon_phone2} />
                  </p>
                </Popover>
                <a
                  href="https://www.facebook.com/profile.php?id=100064504653003#"
                  className="link_icon"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img alt="" src={icon_facebook2} />
                </a>
                <a
                  href="https://www.youtube.com/@GTWealthCanada"
                  className="link_icon"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img alt="" src={icon_youtube2} />
                </a>
                <a
                  href="https://www.instagram.com/gtwealthgroup"
                  className="link_icon"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img alt="" src={icon_instagram2} />
                </a>
              </div>
            </div>
            <img alt="" className="footer_ewm" src={wechat} />
          </div>
        </div>
      </div>
      {/* 右侧 */}
      <div className="right">
        <Popover
          content={<p>Tel: (604) 278-0122</p>}
          title={false}
          placement="left"
        >
          <p className="right_icon" target="_blank">
            <img alt="" src={icon_phone} />
          </p>
        </Popover>
        <Popover
          content={<img src={wechat} alt="" style={{ width: "160px" }} />}
          title="WeChat Connect us"
          placement="left"
          overlayInnerStyle={{
            textAlign: "center",
            width: "100%",
            height: "100%",
            fontSize: "16px",
          }}
        >
          <p className="right_icon">
            <img alt="" src={icon_wx} />
          </p>
        </Popover>
        <a
          href="https://www.facebook.com/profile.php?id=100064504653003#"
          className="right_icon"
          target="_blank"
          rel="noreferrer"
        >
          <img alt="" src={icon_facebook} />
        </a>
        <a
          href="https://www.youtube.com/@GTWealthCanada"
          className="right_icon"
          target="_blank"
          rel="noreferrer"
        >
          <img alt="" src={icon_youtube} />
        </a>
        <a
          href="https://www.instagram.com/gtwealthgroup"
          className="right_icon"
          target="_blank"
          rel="noreferrer"
        >
          <img alt="" src={icon_instagram} />
        </a>
      </div>
    </PageWrapper>
  );
}
export default withRouter(En_Page);
const PageWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
  overflow-x: hidden;
  .bg {
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }
  .bg2 {
    position: absolute;
    bottom: 0;
    left: 0;
  }
  * {
    &::-webkit-scrollbar-track {
      -webkit-box-shadow: none;
      background-color: #fff;
    }
    &::-webkit-scrollbar {
      width: 0.06rem;
      height: 0.05rem;
      background-color: #fff;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #d9d9d9;
      border: none;
      border-radius: 0.06rem;
    }
  }
  .right {
    position: fixed;
    right: 40px;
    top: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .right_icon {
      margin-bottom: 10px;
    }
  }
  .center {
    width: 100%;
    max-width: 1000px;
    display: flex;
    align-items: center;
    flex-direction: column;
    position: relative;
    z-index: 1;
    .center_nav {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 20px 0;
      .center_nav_logo {
        height: 28px;
      }
      .center_nav_li {
        display: flex;
        aling-items: center;
        .link {
          line-height: 10px;
          color: #b3b3b3;
          padding: 0 10px;
          border-left: 1px solid #b3b3b3;
          cursor: pointer;
          &:first-child {
            border: none;
            color: #fff;
          }
          &:hover {
            color: #fff;
          }
        }
      }
    }
    .title_h1 {
      font-size: 50px;
      font-weight: bold;
      color: #fff;
      margin-top: 100px;
    }
    .title_h6 {
      font-size: 20px;
      font-weight: bold;
      margin-top: 60px;
      color: #fff;
      letter-spacing: 0.06em;
    }
    .title_p {
      width: 100%;
      color: rgba(255, 255, 255, 0.6);
      margin-top: 20px;
      font-size: 16px;
      font-weight: 300;
      letter-spacing: 0.06em;
      span {
        font-weight: bold;
        color: #fff;
      }
    }
    .title_p2 {
      margin-top: 20px;
      font-size: 20px;
      font-weight: bold;
      margin-top: 20px;
      color: #fff;
      letter-spacing: 0.06em;
    }
    .center_list {
      width: 100%;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      flex-wrap: wrap;
      margin: 80px 0 20px 0;
      .item {
        width: calc(50% - 10px);
        aspect-ratio: 1 / 0.6;
        position: relative;
        cursor: pointer;
        overflow: hidden;
        border-radius: 10px;
        display: flex;
        margin-bottom: 20px;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .name {
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
          z-index: 1;
          background-color: rgba(0, 0, 0, 0.2);
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: auto;
          p {
            text-align: center;
            font-weight: bold;
            font-size: 28px;
            color: #fff;
          }
        }
        .remark {
          width: 100%;
          height: 100%;
          overflow: auto;
          padding: 10px;
          font-size: 14px;
          color: #fff;
          font-weight: 500;
          position: absolute;
          z-index: 10;
          left: 0;
          top: -100%;
          text-align: center;
          background: rgb(243, 53, 0);
          transition: all 0.3s;
          white-space: pre-wrap;
          word-break: break-word;
          display: flex;
          justify-content: center;
        }
        &:hover {
          .remark {
            top: 0;
          }
        }
      }
    }
  }
  .footer {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin-top: 200px;
    .footer_bg {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }
    .footer_bg_2 {
      position: absolute;
      height: 200px;
      left: 0;
      top: -190px;
    }
    .footer_center {
      width: 100%;
      max-width: 1000px;
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      position: relative;
      z-index: 1;
      .footer_logo {
        height: 30px;
        margin-top: 60px;
      }
      .footer_list {
        width: 100%;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        margin: 60px 0 40px 0;
        .footer_list_li {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          .footer_list_li_title {
            font-size: 16px;
            font-weight: 700;
            color: #02205f;
            margin-bottom: 16px;
          }
          .footer_list_li_p {
            font-size: 12px;
            color: #5a5a5a;
            margin-bottom: 6px;
          }
          .footer_list_li_link {
            display: flex;
            align-items: center;
            .link_icon {
              margin-right: 10px;
            }
          }
        }
        .footer_ewm {
        }
      }
    }
  }
  @media (max-width: 768px) {
    .bg {
      width: auto;
    }
    .center {
      padding: 0 20px;
      .center_nav {
        .center_nav_logo {
          height: 18px;
        }
        .center_nav_li {
          .link {
            font-size: 12px;
          }
        }
      }
      .title_h1 {
        font-size: 16px;
        margin-top: 0;
      }
      .title_h6 {
        width: 100%;
        font-size: 14px;
        margin-top: 0;
        text-align: center;
      }
      .title_p {
        margin-top: 20px;
        font-size: 14px;
      }
      .title_p2 {
        margin-top: 20px;
        width: 100%;
        font-size: 14px;
        margin-top: 40;
        text-align: center;
      }
      .center_list {
        .item {
          width: 100%;
          img {
          }
          .name {
            p {
              font-size: 16px;
            }
          }
          .remark {
            font-size: 12px;
          }
          &:hover {
            .remark {
              top: 0;
            }
          }
        }
      }
    }
    .footer {
      padding: 0 20px;
      margin-top: 50px;
      .footer_bg_2 {
        position: absolute;
        height: 50px;
        left: 0;
        top: -40px;
      }
      .footer_center {
        align-items: center;
        .footer_logo {
          height: 30px;
          margin-top: 30px;
        }
        .footer_list {
          flex-wrap: wrap;
          margin: 20px 0;
          .footer_list_li {
            .footer_list_li_title {
              font-size: 14px;
              margin-bottom: 14px;
            }
            .footer_list_li_link {
              display: flex;
              align-items: center;
              .link_icon {
                margin-right: 10px;
                img {
                  height: 24px;
                }
              }
            }
          }
          .footer_ewm {
          }
        }
      }
    }
    .right {
      display: none;
    }
  }
`;
